<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Actualizar Password">
          <b-form>
            <b-form-group
              label="Usuario"
              label-for="usuarioNombre"
              :label-cols="2"
              v-if="!Boolean(currentVisible)">
              <b-form-input 
                id="usuarioNombre"
                :value= "usuario" 
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Password Actual"
              label-for="currentPass"
              :label-cols="2"
              v-if="Boolean(currentVisible)">
              <b-form-input 
                id="currentPass"
                v-model.trim="$v.currentPass.$model" 
                :state="currentPassValido"
                type="password"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="currentPassFeedback">
                {{ currentPassInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nuevo Password"
              label-for="pass"
              :label-cols="2">
              <b-form-input 
                id="pass"
                v-model.trim="$v.pass.$model" 
                :state="passValido"
                type="password"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="passFeedback">
                {{ passInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Repita el Password"
              label-for="confirmedPass"
              :label-cols="2">
              <b-form-input 
                id="confirmedPass"
                v-model.trim="$v.confirmedPass.$model" 
                :state="confirmedPassValido"
                type="password"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="confirmedPassFeedback">
                {{ confirmedPassInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>

    <div class="fixed-btn">
      <div class="abm-save-btn" @click.prevent="save">
          <i class="fa fa-save fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" @click.prevent="goBack">
          <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { required, requiredIf, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'ABM',
  props: {
    usuarioId: {
      type: Number,
      default: 0
    },
    usuario: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,
      
      currentVisible: true,
      currentPass: '',
      pass: '',
      confirmedPass: '',

      noValidar: true,
      currentPassValido: null,
      currentPassInvalidoMsj: '',
      passValido: null,
      passInvalidoMsj: '',
      confirmedPassValido: null,
      confirmedPassInvalidoMsj: '',
    }
  },
  created() {
    this.currentVisible = Boolean(this.usuarioId == 0 ? true : false);
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "currentPass" || validarTodos) {
        if (this.$v.currentPass.$error) {
          this.currentPassValido = false;
          if (!this.$v.currentPass.required) {
            this.currentPassInvalidoMsj = 'Debe ingresar el password actual';
          } else if (!this.$v.apellido.minLength || !this.$v.apellido.maxLength) {
            this.currentPassInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres';
          }
        } else {
          this.currentPassValido = null;
          this.currentPassInvalidoMsj = '';
        }
      }
      if (campo == "pass" || validarTodos) {
        if (this.$v.pass.$error) {
          this.passValido = false;
          if (!this.$v.pass.required) {
            this.passInvalidoMsj = 'Debe ingresar el nuevo password.';
          } else if (!this.$v.pass.minLength || !this.$v.pass.maxLength || !this.$v.pass.strongPass) {
            this.passInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
          }
        } else {
          this.passValido = null;
          this.passInvalidoMsj = '';
        }
      }
      if (campo == "confirmedPass" || validarTodos) {
        if (this.$v.confirmedPass.$error) {
          this.confirmedPassValido = false;
          if (!this.$v.confirmedPass.sameAs) {
            this.confirmedPassInvalidoMsj = 'El nuevo password no coincide con su confirmación.';
          }
        } else {
          this.confirmedPassValido = null;
          this.confirmedPassInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let usuarioId = 0;
        if (this.usuarioId) {
          usuarioId = this.usuarioId;
        }

        let params = {
          usuarioId: usuarioId,
          current: this.currentPass,
          pass: this.pass
        }
        this.$store.dispatch('usuarioperfil/updatePassword', params)
          .then( res => {
            this.modalOkAction = this.goBack;
            this.modalHiddenAction = this.goBack;
            this.modalMensaje = "La contraseña se actualizó con éxito.";
            this.modalMsj = true;
          })
          .catch( error => {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = error.errorMessage;
            this.modalMsj = true;
          })
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  validations: {
    currentPass: {
      required,
      required: requiredIf(function () {
        return Boolean(this.usuarioId == 0 ? true : false);
      }),      
    },
    pass: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      strongPass: function(value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        // const containsSpecial = /[#?!@$%^&*-]/.test(value);
        
        // return containsUppercase && containsLowercase && containsNumber && containsSpecial;
        return containsUppercase & containsLowercase & containsNumber;
      }
      /* "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$" */
    },
    confirmedPass: {
      sameAs: sameAs('pass')
    },
  },  
}
</script>

<style>
</style>
